import React, { useContext, useState, type ReactNode } from "react";

interface TemplateSearchParams {
  templates: unknown[];
  experienceLevel: string;
  bodyPart: string;
  secondaryMuscle: string;
  gender: string;
  numberOfElements: number;
  numberOfWorkouts: number;
  keyword: string;
  pageId: number;
  hasMoreData: boolean;
  isLoading: boolean;
}

interface SearchContextValue {
  templateSearchParams: Partial<TemplateSearchParams>;
  setTemplateSearchParams: React.Dispatch<
    React.SetStateAction<Partial<TemplateSearchParams>>
  >;
}

// Create the Search Context
const SearchContext = React.createContext<SearchContextValue>({
  templateSearchParams: {},
  setTemplateSearchParams: () => {},
});

// Custom hook to access the Search Context
export function useSearchContext(): SearchContextValue {
  return useContext(SearchContext);
}

// Provider for the Search Context
export function SearchProvider({ children }: { children: ReactNode }) {
  // Correctly initialize state with useState
  const [templateSearchParams, setTemplateSearchParams] = useState<
    Partial<TemplateSearchParams>
  >({
    templates: [],
    experienceLevel: "ALL",
    bodyPart: "null",
    secondaryMuscle: "null",
    gender: "null",
    numberOfElements: 0,
    numberOfWorkouts: 0,
    keyword: "",
    pageId: 0,
    hasMoreData: true,
    isLoading: true,
  });

  // Value to be provided to the context
  const value = {
    templateSearchParams,
    setTemplateSearchParams,
  };

  return (
      <SearchContext.Provider value={value}>
        {children}
      </SearchContext.Provider>
  );
}
